import Loadable from "@loadable/component";

const RePopulateCartPage = Loadable(
  () =>
    import(/* webpackChunkName: "re_populate_cart_page" */ "./rePopulateCart")
);

export default RePopulateCartPage;
